module.exports = __webpack_public_path__ + "static/media/iv_analyst_view.134c3872.svg";